<ng-container *ngIf="is_loading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>

<div style="margin-top: 30px">
  <form [formGroup]="myForm" (ngSubmit)="onSubmit()"  novalidate>

    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">

      <div>
        <mat-card style="width: 300px; height: 100%">
          <mat-toolbar color="primary" class="mat-elevation-z16">
            <mat-toolbar-row>
              <span>Create New Password</span>
            </mat-toolbar-row>
          </mat-toolbar>


          <mat-card-content fxLayout="column">
            <mat-form-field style="margin-top: 15px">
              <mat-label>Email:</mat-label>
              <input matInput type="email" placeholder="me@user.com"  formControlName="email" autocomplete="email" (focus)="onFocus()">
              <mat-error>
                <strong>Valid email address required</strong>
              </mat-error>
            </mat-form-field>

          <mat-form-field style="margin-top: 15px">
            <mat-label>code:</mat-label>
            <input matInput type="text" placeholder="code"  formControlName="code" autocomplete="code" (focus)="onFocus()">
            <mat-error>
              <strong>Code required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field style="margin-top: 15px">
            <mat-label>Password:</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" placeholder="password" formControlName="password" autocomplete="current-password" (focus)="onFocus()">
            <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
              <mat-icon class="add-button">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error>
              <strong>Requires at least 1 Uppercase, Lowercase, Number and Special Character and min lentgh of 8 </strong>
            </mat-error>
          </mat-form-field>
          </mat-card-content>

          <div *ngIf="is_form_error">
            <mat-error style="margin-bottom: 5px">
              <strong>{{form_error_message}}</strong>
            </mat-error>
          </div>


          <br>
          <button mat-raised-button color="accent" [disabled]="!myForm.valid" type="submit">Submit</button>
          <a style="margin-left: 10px" routerLinkActive="active" [routerLink]="['/login']">Login</a>

          <!--          <mat-progress-bar *ngIf="is_loading" mode="indeterminate" style="margin-top: 10px"></mat-progress-bar>-->
        </mat-card>
      </div>
    </div>

  </form>
</div>
